import React from 'react';
import { motion } from 'framer-motion';
import { GraduationCap, Clock, CalendarDays, CheckCircle2, ArrowRight } from 'lucide-react';
const syllabus = ['Principio de diseños', 'Análisis del cráneo', 'Análisis de corte', 'Análisis de tu cliente', 'Cortes clásicos (totalmente a tijera)', 'Técnica del degradé (Varios estilos)', 'Peinados (Diferentes estilos y formas)', 'Posturas de trabajo (Cómo prevenir lesiones)', 'Uso correcto de las herramientas', 'Atención al cliente', 'Limpieza y mantenimiento de las herramientas', 'Clases demostrativas, teóricas y prácticas', 'Todo lo que necesitas para ser un buen barbero 🥷🙏🏼'];
export function Academy() {
  return <section id="academia" className="py-32 relative bg-[#050505]" data-id="element-36" data-mp="170i3d3lqn4t0">
      {/* Background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-64 bg-neon-violet/5 rounded-full blur-[120px] pointer-events-none transform-gpu will-change-transform" data-id="element-37" data-mp="2ne8bclfzad7x" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-38" data-mp="3et5nd9zze14w">
        <div className="text-center mb-16" data-id="element-39" data-mp="3ev092qj2txa1">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-display text-5xl md:text-7xl mb-4" data-id="element-40" data-mp="3jqpdp89ye4d7">
            Formación{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-neon-violet to-neon-green" data-id="element-41" data-mp="3118zxj99cfeu">
              Profesional
            </span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-42" data-mp="35z0z8yc8f3t2">
            Conviértete en un experto de la barbería con nuestro curso intensivo
            y completo.
          </motion.p>
        </div>

        <div className="grid lg:grid-cols-12 gap-8 lg:gap-12" data-id="element-43" data-mp="2k0ektz0xmhlo">
          {/* Course Info Card */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="lg:col-span-5" data-id="element-44" data-mp="2f08pa7rjkayb">
            <div className="bg-white/[0.03] border border-white/10 backdrop-blur-lg rounded-3xl p-8 sticky top-32" data-id="element-45" data-mp="219nel6c8r7bi">
              <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-neon-violet to-fuchsia-500 p-[1px] mb-8" data-id="element-46" data-mp="1w9hkljii18q9">
                <div className="w-full h-full bg-[#0a0a0a] rounded-2xl flex items-center justify-center" data-id="element-47" data-mp="3cmpkn7gpsehf">
                  <GraduationCap size={32} className="text-white" data-id="element-48" data-mp="37p63nzsmtnls" />
                </div>
              </div>

              <h3 className="text-3xl font-bold mb-6 text-white" data-id="element-49" data-mp="3fb1kztrxy3tl">
                Curso Completo de Barbería
              </h3>

              <div className="space-y-6 mb-8" data-id="element-50" data-mp="368k31rjbjxce">
                <div className="flex items-center gap-4 text-gray-300" data-id="element-51" data-mp="369v6trcrl53i">
                  <div className="w-12 h-12 rounded-full bg-white/5 flex items-center justify-center shrink-0" data-id="element-52" data-mp="3aax6286olh5h">
                    <CalendarDays className="text-neon-violet" size={24} data-id="element-53" data-mp="1vdf5fthgatl" />
                  </div>
                  <div data-id="element-54" data-mp="6ru58fk8sz9b">
                    <p className="text-sm text-gray-500 font-medium uppercase tracking-wider" data-id="element-55" data-mp="6v9kbidx28aq">
                      Duración
                    </p>
                    <p className="font-semibold text-lg" data-id="element-56" data-mp="3t7yczyjsprc2">6 Meses</p>
                  </div>
                </div>

                <div className="flex items-center gap-4 text-gray-300" data-id="element-57" data-mp="krvdwh6r1azc">
                  <div className="w-12 h-12 rounded-full bg-white/5 flex items-center justify-center shrink-0" data-id="element-58" data-mp="pk6frpl1v6uj">
                    <Clock className="text-neon-green" size={24} data-id="element-59" data-mp="2y0zcwtpgb5y6" />
                  </div>
                  <div data-id="element-60" data-mp="2t138itcudci3">
                    <p className="text-sm text-gray-500 font-medium uppercase tracking-wider" data-id="element-61" data-mp="2t0uvn1gpy76w">
                      Frecuencia
                    </p>
                    <p className="font-semibold text-lg" data-id="element-62" data-mp="2k0y32or7ko6k">
                      2 clases semanales (2hs aprox)
                    </p>
                  </div>
                </div>
              </div>

              <a href="https://wa.me/59897581636" target="_blank" rel="noreferrer" className="w-full py-4 rounded-xl bg-gradient-to-r from-neon-violet to-neon-green text-white font-bold text-lg flex items-center justify-center gap-2 hover:scale-105 transition-transform shadow-[0_0_20px_rgba(168,85,247,0.3)]" data-id="element-63" data-mp="3bs44r9mkutxy">
                Inscribirme Ahora
                <ArrowRight size={20} data-id="element-64" data-mp="3uqq86v5kgx51" />
              </a>
            </div>
          </motion.div>

          {/* Syllabus List */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="lg:col-span-7 bg-white/[0.02] border border-white/5 rounded-3xl p-8 md:p-10" data-id="element-65" data-mp="1h9ww8w160wzq">
            <h4 className="text-2xl font-semibold mb-8 text-white flex items-center gap-3" data-id="element-66" data-mp="207zpxo4nri3v">
              ¿Qué aprenderás en este curso?
            </h4>

            <div className="grid sm:grid-cols-2 gap-x-6 gap-y-4" data-id="element-67" data-mp="253y9myf1kbxy">
              {syllabus.map((item, index) => <div key={index} className="flex items-start gap-3 group" data-id="element-68" data-mp="2dyl9zg5uly3c" data-mpi={index}>
                  <CheckCircle2 size={20} className="text-neon-green shrink-0 mt-0.5 group-hover:scale-110 transition-transform" data-id="element-69" data-mp="2e0pcpus0gr21" />
                  <span className="text-gray-300 leading-relaxed" data-id="element-70" data-mp="2nx24uo7wqwuo">{item}</span>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}